import * as React from "react";
const SvgCheckbox = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.222 4.36A14 14 0 0 1 16 2a14.04 14.04 0 0 1 14 14A14 14 0 1 1 8.222 4.36m15.38 6.061c.42.423.42 1.108 0 1.53l-9.883 9.944-5.321-5.354a1.087 1.087 0 0 1 0-1.53 1.07 1.07 0 0 1 1.52 0l3.801 3.824 8.362-8.414a1.07 1.07 0 0 1 1.521 0",
    clipRule: "evenodd"
  }
));
export default SvgCheckbox;
